var subDomainUrl = process.env.PUBLIC_URL.split("/");
var dev = {
    baseRoot: "https://vamauat.nuvamawealth.com/salesjourneydev/",
    applicationRoot: "http://localhost:8080/",
    apiBaseElasticSearch: "https://reportsuat.nuvamawealth.com/",
    apiBase: "https://reportsuat.nuvamawealth.com/",
    forgotLoginIdURL: "http://edesionuatcip02.ewmwealth.in/cip/login.aspx",
    customerServiceRedirect: "CustomerService/createService",
    applicationFolder: window.location.protocol + "//" + window.location.hostname + ":8080/",
    casAdvisoryUrl: "https://marsdev.pickright.co.in/",
    bullpenDirectionBaseUrl: "http://edesionuatcip02.ewmwealth.in/Distribution",
    atpayoutDirectionBaseUrl: "at-payout/dashboard",
    salesClientReport: "https://vamauat.nuvamawealth.com/reports-hotfix/reports/sales",
    productFAQLink: "https://www.nuvamawealth.com/cas/microsite/RM-portal-new/index.html",
    envName: "UAT",
    aopBaseURL: "https://nwuat.nuvamawealth.com/",
    quotesBase: "https://vamacug.nuvamawealth.com/cug/alpha/rm-web/",
    supersetDomain: "https://10.32.10.37:4000",
    investmentJourneyBaseUrl: "https://reportsuat.nuvamawealth.com/",
};
var uat = {
    baseRoot: "https://vamauat.nuvamawealth.com/",
    applicationRoot: "https://vamauat.nuvamawealth.com/aopjourneys/",
    apiBase: "https://reportsuat.nuvamawealth.com/",
    apiBaseElasticSearch: "https://reportsuat.nuvamawealth.com/",
    forgotLoginIdURL: "http://edesionuatcip02.ewmwealth.in/cip/login.aspx",
    customerServiceRedirect: "CustomerService/createService",
    applicationFolder: window.location.protocol +
        "//" +
        window.location.hostname +
        "/aopjourneys/",
    casAdvisoryUrl: "https://marsuat.pickright.co.in/",
    bullpenDirectionBaseUrl: "http://edesionuatcip02.ewmwealth.in/Distribution",
    atpayoutDirectionBaseUrl: "at-payout/dashboard",
    salesClientReport: "https://vamauat.nuvamawealth.com/reports-hotfix/reports/sales",
    productFAQLink: "https://www.nuvamawealth.com/cas/microsite/RM-portal-new/index.html",
    tenantID: "9201f936-0a1d-49af-82ee-4ee4345c1ad7",
    clientID: "248bd7bc-42d7-408b-8f3e-aad0d90fb579",
    envName: "UAT",
    aopBaseURL: "https://nwuat.nuvamawealth.com/",
    quotesBase: "https://vamacug.nuvamawealth.com/cug/alpha/rm-web/",
    supersetDomain: "https://10.32.10.37:4000",
    investmentJourneyBaseUrl: "https://reportsuat.nuvamawealth.com/",
};
var cug = {
    baseRoot: "https://vamacug.nuvamawealth.com/",
    applicationRoot: "https://vamacug.nuvamawealth.com/salesjourney/",
    apiBase: "https://nwopmscug.nuvamawealth.com/",
    forgotLoginIdURL: "https://apps.nuvamawealth.com/cip/login.aspx",
    customerServiceRedirect: "CustomerService/createService",
    applicationFolder: window.location.protocol +
        "//" +
        window.location.hostname +
        "/salesjourney/",
    casAdvisoryUrl: "https://mars.pickright.in/",
    bullpenDirectionBaseUrl: "",
    atpayoutDirectionBaseUrl: "at-payout/dashboard",
    salesClientReport: "https://vamacug.nuvamawealth.com/new-features1/reports/sales",
    productFAQLink: "https://www.nuvamawealth.com/cas/microsite/RM-portal-new/index.html",
    envName: "CUG",
    tenantID: "9201f936-0a1d-49af-82ee-4ee4345c1ad7",
    clientID: "22348307-63d1-4119-969d-0263880db0a4",
    apiBaseElasticSearch: "https://nwopmscug.nuvamawealth.com/",
    aopBaseURL: "https://nwuat.nuvamawealth.com/",
    quotesBase: "https://vamacug.nuvamawealth.com/cug/alpha/rm-web/",
    supersetDomain: "https://10.32.10.37:4000",
    investmentJourneyBaseUrl: "https://nwopmscug.nuvamawealth.com/",
};
var prod = {
    baseRoot: "https://www.nuvamawealth.com/",
    applicationRoot: "https://www.nuvamawealth.com/sales/",
    apiBase: "https://nwopms.nuvamawealth.com/",
    forgotLoginIdURL: "https://apps.nuvamawealth.com/cip/login.aspx",
    customerServiceRedirect: "CustomerService/createService",
    applicationFolder: window.location.protocol + "//" + window.location.hostname + "/sales/",
    casAdvisoryUrl: "https://cas.pickright.in/",
    bullpenDirectionBaseUrl: "https://apps.nuvamawealth.com/Distribution",
    atpayoutDirectionBaseUrl: "at-payout/dashboard",
    salesClientReport: "/new-features/reports/sales",
    productFAQLink: "https://www.nuvamawealth.com/cas/microsite/RM-portal-new/index.html",
    envName: "PROD",
    tenantID: "9201f936-0a1d-49af-82ee-4ee4345c1ad7",
    clientID: "dd6ef68a-6dca-4acd-b4e7-309938a0c13f",
    apiBaseElasticSearch: "https://nwopms.nuvamawealth.com/",
    aopBaseURL: "https://nwopms.nuvamawealth.com/",
    quotesBase: "https://www.nuvamawealth.com/rm-beta/",
    supersetDomain: "https://nwopmsss.nuvamawealth.com",
    investmentJourneyBaseUrl: "https://nwopms.nuvamawealth.com/",
};
export var config = process.env.NODE_ENV === "production"
    ? prod
    : process.env.NODE_ENV === "cug"
        ? cug
        : process.env.NODE_ENV === "uat"
            ? uat
            : dev;
export default config;
